/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IConsumable } from 'app/shared/model/consumable.model';
import { IConsumableOrder } from 'app/shared/model/consumable-order.model';

export interface IConsumableOrderItem {
  id?: string;
  remarks?: string | null;
  quantity?: number;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  consumable?: IConsumable;
  order?: IConsumableOrder;
}

export const defaultValue: Readonly<IConsumableOrderItem> = {
  active: false,
};
